import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wifi",
  "use": "icon-wifi-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-wifi\" id=\"icon-wifi\"><path d=\"M5 12.55a11 11 0 0 1 14.08 0\" /><path d=\"M1.42 9a16 16 0 0 1 21.16 0\" /><path d=\"M8.53 16.11a6 6 0 0 1 6.95 0\" /><line x1=\"12\" y1=\"20\" x2=\"12.01\" y2=\"20\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol